  import {
    trapFocusOnModal
  } from '../javascripts/trap-focus-on-modal';

  (async () => {
    if (document.querySelector('.Modal')) {
      const {
        default: SwipeListener
      } = await import( /* webpackChunkName: 'swipe-listener' */ 'swipe-listener');
      const ESC_KEY = 27;
      const cardCoordinatesToInitSwipe = 500;
      const body = document.querySelector('body');
      const modal = body.querySelector('.Modal');
      const buttons = body.querySelectorAll('.Card-storyBtn');
      const breakpoint = window.matchMedia('(max-width: 992px)');

      const showModal = evt => {
        evt.preventDefault();
        const storyTheme = evt.target.closest('.Card-transformed').getAttribute('data-story-theme');
        modal.classList.remove('Modal--hide');
        const story = modal.querySelector(`.Story[data-story-theme=${storyTheme}]`);
        story.classList.remove('Story--hide');
        body.style.overflow = 'hidden';
        story.querySelector('.Button').focus();
        trapFocusOnModal(story);
      }

      const closeModal = () => {
        const stories = body.querySelectorAll('.Story');
        stories.forEach(story => story.classList.add('Story--hide'));
        modal.classList.add('Modal--hide');
        body.style.overflow = 'visible';
      }

      const closeModalWithOverlay = evt => {
        if (evt.target == modal) {
          closeModal();
        }
      }

      const closeModalWithEsc = evt => {
        if (evt.keyCode === ESC_KEY) {
          evt.preventDefault();
          closeModal();
        }
      }

      const breakpointChecker = () => {
        const modalContent = modal.querySelector('.Modal-content');
        const listener = SwipeListener(modalContent);

        if (breakpoint.matches && modal.classList.contains('Modal--hide')) {
          buttons.forEach(button => button.removeEventListener('click', showModal));
          window.removeEventListener('keydown', closeModalWithEsc);
          modal.removeEventListener('click', closeModalWithOverlay);
          listener.off();
        } else {
          modalContent.addEventListener('swipe', evt => {
            const directions = evt.detail.directions;
            const y = evt.detail.y;
            if (directions.bottom && y[1] > cardCoordinatesToInitSwipe) {
              closeModal();
            }
          })

          buttons.forEach(button => button.addEventListener('click', showModal));
          window.addEventListener('keydown', closeModalWithEsc);
          modal.addEventListener('click', closeModalWithOverlay);
        }
      }

      breakpointChecker();
      breakpoint.addListener(breakpointChecker);
    }
  })();
